import * as yup from 'yup';

export const schema = yup
  .object({
    list: yup.array(),
    list_title: yup.string(),
    primary_button_text: yup.string(),
    secondary_button_text: yup.string(),
    title: yup.string(),
  })
  .transform(value =>
    value
      ? {
          list: value.list,
          listTitle: value.list_title,
          primaryButtonText: value.primary_button_text,
          secondaryButtonText: value.secondary_button_text,
          title: value.title,
        }
      : undefined,
  );
